export { default as isCompanyViewRoute } from './isCompanyViewRoute';
